import { ACTION_TYPES } from '../../constants/store.constants';
import { getLanguages, postInterpreterApi } from '../../service/interpreter.service';
import { INTERPRETER_AUDIO, INTERPRETER_VIDEO, SCAL_REGION } from '../../constants/interpreter.constants';
import setErrorAction from './errorActions';
import ServiceAreaAction from './ServiceAreaAction';

const setInterpreterType = data => ({
  type: ACTION_TYPES.SET_INTERPRETER_TYPE,
  payload: data
});

const setInterpreterLanguage = data => dispatch => {
  dispatch({ type: ACTION_TYPES.SET_INTERPRETER_LANGUAGE, payload: data });
  const inviteButtonStatus = !!data;
  dispatch({ type: ACTION_TYPES.ENABLE_INVITE_BUTTON, payload: inviteButtonStatus });
  if (data) {
    dispatch({ type: ACTION_TYPES.SET_INTERPRETER_SUPPRESS_AUTO_SELECT, payload: false });
  }
};

const setInterpreterSearchQuery = data => ({
  type: ACTION_TYPES.SET_INTERPRETER_SEARCH_QUERY,
  payload: data
});

const setInterpreterSuppressAutoSelect = data => ({
  type: ACTION_TYPES.SET_INTERPRETER_SUPPRESS_AUTO_SELECT,
  payload: data
});

const setServiceAreaIsLoading = data => ({
  type: ACTION_TYPES.SET_SERVICE_AREA_IS_LOADING,
  payload: data
});

const setInterpreterLanguageList = data => ({
  type: ACTION_TYPES.SET_INTERPRETER_LANGUAGE_LIST,
  payload: data
});

const setDisplayLanguageList = language => ({
  type: ACTION_TYPES.SET_INTERPRETER_DISPLAY_LIST,
  payload: language
});

const fetchInterpreterLanguages =
  (interpreterLanguageList, payload, { preSelect = true } = {}) =>
  async dispatch => {
    const preSelectLanguage = data => dispatch(setInterpreterLanguage(data));
    const setDisplayData = data =>
      dispatch({
        type: ACTION_TYPES.SET_INTERPRETER_DISPLAY_LIST,
        payload: data
      });
    const setInterpreterLanguageData = data =>
      dispatch({
        type: ACTION_TYPES.SET_INTERPRETER_LANGUAGE_LIST,
        payload: data
      });
    try {
      let data = null;
      if (interpreterLanguageList?.length > 0) {
        data = interpreterLanguageList;
      } else {
        data = await getLanguages(payload);
      }
      if (!data?.error && data.length > 0) {
        setInterpreterLanguageData(data);
        if (preSelect) {
          preSelectLanguage(data[0]);
        }
        setDisplayData(data);
        return data;
      }
    } catch (err) {
      dispatch(setErrorAction.setErrorHandler(err));
    }
  };

const postInterpreterAction = (interpreterPayload, appConfig) => async dispatch => {
  try {
    if (interpreterPayload) {
      dispatch({ type: ACTION_TYPES.SET_MENU_ITEM_DISABLE, payload: false });
      dispatch({ type: ACTION_TYPES.ENABLE_INVITE_BUTTON, payload: false });
      const response = await postInterpreterApi(interpreterPayload);
      if (response?.status) {
        if (response?.sessionID) {
          dispatch({ type: ACTION_TYPES.SET_TPLC_SESSIONID, payload: { sessionID: response.sessionID } });
        }
        dispatch({ type: ACTION_TYPES.INVITE_BUTTON_CLICKED, payload: { inviteButtonClicked: true, status: true } });
        dispatch(setInterpreterLanguage(null));
        dispatch(setInterpreterSuppressAutoSelect(true));
        const isVideoInvite = interpreterPayload?.interpreter?.mode === INTERPRETER_VIDEO.toUpperCase();
        const isScalAudioInvite =
          interpreterPayload?.interpreter?.mode === INTERPRETER_AUDIO.toUpperCase() &&
          interpreterPayload?.region?.trim?.().toUpperCase() === SCAL_REGION;
        if (appConfig) {
          dispatch(
            ServiceAreaAction.setInviteButtonEnable(appConfig, {
              disableLanguageListDuringCooldown: isVideoInvite,
              disableServiceAreaDuringCooldown: isScalAudioInvite
            })
          );
        }
      }
    }
  } catch (err) {
    dispatch({ type: ACTION_TYPES.SET_MENU_ITEM_DISABLE, payload: true });
    dispatch(setErrorAction.setErrorHandler(err));
  }
};

const disableLanguageList = data => ({
  type: ACTION_TYPES.DISABLE_LANGUAGE_LIST,
  payload: data
});

const setJoinedInterpreterList = payload => dispatch => {
  if (Array.isArray(payload) && payload.length > 0) {
    dispatch({ type: ACTION_TYPES.SET_JOINED_INTERPRETER_LIST, payload });
  } else {
    dispatch({ type: ACTION_TYPES.SET_JOINED_INTERPRETER_LIST, payload: [] });
  }
};
export const setVideoJoinedInterpreterList = payload => dispatch => {
  if (Array.isArray(payload) && payload.length > 0) {
    dispatch({ type: ACTION_TYPES.SET_VIDEO_JOINED_INTERPRETER_LIST, payload });
  } else {
    dispatch({ type: ACTION_TYPES.SET_VIDEO_JOINED_INTERPRETER_LIST, payload: [] });
  }
};

export const setAudioJoinedInterpreterList = payload => dispatch => {
  if (Array.isArray(payload) && payload.length > 0) {
    dispatch({ type: ACTION_TYPES.SET_AUDIO_JOINED_INTERPRETER_LIST, payload });
  } else {
    dispatch({ type: ACTION_TYPES.SET_AUDIO_JOINED_INTERPRETER_LIST, payload: [] });
  }
};

export default {
  setInterpreterType,
  setInterpreterLanguage,
  setInterpreterSearchQuery,
  setServiceAreaIsLoading,
  setInterpreterLanguageList,
  fetchInterpreterLanguages,
  setDisplayLanguageList,
  setInterpreterSuppressAutoSelect,
  postInterpreterAction,
  disableLanguageList,
  setJoinedInterpreterList,
  setVideoJoinedInterpreterList,
  setAudioJoinedInterpreterList
};
